module.exports = __webpack_public_path__ + "img/90.ad018c92.png";